@if (testCaseId(); as _tcId) {
  <div class="hc">
    <div class="hc__header">
      <span class="hc__label">{{ 'testCases.form.handover.label' | translate }}</span>
      @if (!readonly()) {
        <div class="hc__actions">
          @if (!closed()) {
            <button
              type="button"
              class="hc__btn hc__btn--handoff"
              [attr.aria-expanded]="handoffPanelOpen()"
              aria-controls="hc-handoff-panel"
              [disabled]="currentOwnerAlreadyHandedOff() || pendingUserId() !== null"
              [title]="currentOwnerAlreadyHandedOff() ? ('testCases.form.handover.alreadyHandedOff' | translate) : ''"
              (click)="handoffPanelOpen() ? onCloseHandoffPanel() : onOpenHandoff()"
            >
              <mat-icon aria-hidden="true">reply</mat-icon>
              {{ 'testCases.form.handover.handoff' | translate }}
            </button>
            <button type="button" class="hc__btn hc__btn--close" (click)="onCloseChain()">
              <mat-icon aria-hidden="true">check</mat-icon>
              {{ 'testCases.form.handover.close' | translate }}
            </button>
          } @else {
            <button type="button" class="hc__btn hc__btn--reopen" (click)="onReopenChain()">
              {{ 'testCases.form.handover.reopen' | translate }}
            </button>
          }
        </div>
      }
    </div>

    <div class="hc__chain" role="list">
      @for (stage of stages(); track stage.id; let last = $last) {
        <div class="hc__stage" role="listitem">
          <div class="hc__avatar" [class.hc__avatar--active]="isActive(stage)" [title]="fullName(stage)">
            <app-avatar [name]="fullName(stage) || '?'" [size]="26" />
            @if (closed() && last && !pendingStage()) {
              <span class="hc__check" aria-hidden="true">
                <mat-icon>check</mat-icon>
              </span>
            }
          </div>
          <span class="hc__name" [class.hc__name--active]="isActive(stage)">{{ firstName(stage) }}</span>
        </div>
        @if (!last || pendingStage()) {
          <span class="hc__sep" aria-hidden="true">→</span>
        }
      }
      @if (pendingStage(); as draft) {
        <div class="hc__stage hc__stage--draft" role="listitem">
          <div class="hc__avatar hc__avatar--draft" [title]="fullName(draft)">
            <app-avatar [name]="fullName(draft) || '?'" [size]="26" />
          </div>
          <span class="hc__name hc__name--draft">{{ firstName(draft) }}</span>
          <button
            type="button"
            class="hc__draft-remove"
            [attr.aria-label]="'testCases.form.handover.discardDraft' | translate"
            (click)="onDiscardDraft()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <span class="hc__pill hc__pill--draft">{{ 'testCases.form.handover.draftPill' | translate }}</span>
      }
      @if (closed() && !pendingStage()) {
        <span class="hc__pill">{{ 'testCases.form.handover.pillClosed' | translate }}</span>
      }
    </div>

    @if (currentOwnerAlreadyHandedOff() && !readonly()) {
      <p class="hc__notice" role="status">
        {{ 'testCases.form.handover.alreadyHandedOff' | translate }}
      </p>
    }

    @if (handoffPanelOpen() && !readonly()) {
      <div id="hc-handoff-panel" class="hc__panel" role="region">
        <app-person-select
          [formControl]="selectedUserId"
          [label]="'testCases.form.handover.handoffTo' | translate"
          [options]="selectablePersonOptions()"
          [required]="true"
          [allowNone]="false"
        />
        <button
          type="button"
          class="hc__btn hc__btn--submit"
          [disabled]="!selectedUserId.value || currentOwnerAlreadyHandedOff()"
          (click)="onSubmitHandoff()"
        >
          {{ 'testCases.form.handover.submit' | translate }}
        </button>
      </div>
      <p class="hc__hint">
        {{ 'testCases.form.handover.onceHint' | translate }}
      </p>
    }

    <div class="hc__divider" aria-hidden="true"></div>
  </div>
}
